import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NewsComponent } from './news.component';
import { DragulaModule, DragulaService } from 'ng2-dragula';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    DragulaModule
  ],
  declarations: [NewsComponent],
  providers: [DragulaService]
})
export class NewsModule { }



// WEBPACK FOOTER //
// ./src/app/news/news.module.ts